import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Courses = () => {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editing, setEditing] = useState(null);
    const [formData, setFormData] = useState({
        title: '',          // ✅ Changed from 'name' to 'title'
        category: '',
        description: '',
        duration: '',
        fee: '',
        level: 'Beginner',
        is_active: true,
        is_featured: false,
    });
    const [errors, setErrors] = useState({});
    const [serverError, setServerError] = useState(null);

    const levels = ['Beginner', 'Intermediate', 'Advanced'];

    useEffect(() => {
        fetchCourses();
    }, []);

    const fetchCourses = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('admin_token');
            
            const response = await axios.get('http://localhost:8000/api/admin/courses', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            
            console.log('Courses response:', response.data);
            setCourses(response.data);
        } catch (error) {
            console.error('Error fetching courses:', error);
            if (error.response) {
                console.error('Response status:', error.response.status);
                console.error('Response data:', error.response.data);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setServerError(null);
        
        // ✅ Changed from 'name' to 'title'
        const dataToSend = {
            title: formData.title,
            category: formData.category,
            description: formData.description || '',
            duration: formData.duration,
            fee: formData.fee || '',
            level: formData.level,
            is_active: formData.is_active ? 1 : 0,
            is_featured: formData.is_featured ? 1 : 0,
        };

        console.log('Sending data:', dataToSend);

        try {
            const token = localStorage.getItem('admin_token');
            
            if (editing) {
                const response = await axios.put(
                    `http://localhost:8000/api/admin/courses/${editing.id}`,
                    dataToSend,
                    {
                        headers: { 
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );
                console.log('Update success:', response.data);
            } else {
                const response = await axios.post(
                    'http://localhost:8000/api/admin/courses',
                    dataToSend,
                    {
                        headers: { 
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );
                console.log('Create success:', response.data);
            }
            
            fetchCourses();
            resetForm();
        } catch (error) {
            console.error('=== FULL ERROR DETAILS ===');
            console.error('Error object:', error);
            
            if (error.response) {
                console.error('Response status:', error.response.status);
                console.error('Response data:', error.response.data);
                
                if (error.response.status === 422) {
                    const validationErrors = error.response.data.errors || {};
                    setErrors(validationErrors);
                    
                    const errorMessages = Object.values(validationErrors).flat();
                    if (errorMessages.length > 0) {
                        setServerError('Validation Error: ' + errorMessages.join(', '));
                    } else {
                        setServerError('Please check your input and try again.');
                    }
                } else if (error.response.status === 500) {
                    let errorMessage = 'Internal server error occurred';
                    if (error.response.data && typeof error.response.data === 'object') {
                        if (error.response.data.message) {
                            errorMessage = error.response.data.message;
                        }
                        if (error.response.data.error) {
                            errorMessage = error.response.data.error;
                        }
                    }
                    setServerError(errorMessage);
                } else {
                    setServerError('Error: ' + (error.response.data?.message || error.response.statusText || 'Unknown error'));
                }
            } else if (error.request) {
                setServerError('No response from server. Please check if the server is running.');
            } else {
                setServerError(error.message);
            }
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this course?')) {
            try {
                const token = localStorage.getItem('admin_token');
                await axios.delete(`http://localhost:8000/api/admin/courses/${id}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                fetchCourses();
            } catch (error) {
                console.error('Error deleting course:', error);
                if (error.response) {
                    setServerError('Failed to delete course: ' + (error.response.data?.message || 'Unknown error'));
                } else {
                    setServerError('Failed to delete course. Please try again.');
                }
            }
        }
    };

    const handleEdit = (course) => {
        console.log('Editing course:', course);
        setEditing(course);
        setFormData({
            title: course.title || '',          // ✅ Changed from 'name' to 'title'
            category: course.category || '',
            description: course.description || '',
            duration: course.duration || '',
            fee: course.fee || '',
            level: course.level || 'Beginner',
            is_active: course.is_active === 1 || course.is_active === true,
            is_featured: course.is_featured === 1 || course.is_featured === true,
        });
        setShowModal(true);
        setErrors({});
        setServerError(null);
    };

    const resetForm = () => {
        setFormData({
            title: '',
            category: '',
            description: '',
            duration: '',
            fee: '',
            level: 'Beginner',
            is_active: true,
            is_featured: false,
        });
        setEditing(null);
        setShowModal(false);
        setErrors({});
        setServerError(null);
    };

    if (loading) {
        return (
            <div className="admin-loading" style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '200px',
                fontSize: '1.1rem',
                color: '#6b7a8f'
            }}>
                Loading courses...
            </div>
        );
    }

    return (
        <div>
            <div className="admin-header">
                <h2>Courses Management</h2>
                <button className="admin-add-btn" onClick={() => setShowModal(true)}>
                    + Add New Course
                </button>
            </div>

            {courses.length === 0 ? (
                <div style={{ 
                    textAlign: 'center', 
                    padding: '3rem', 
                    color: '#6b7a8f',
                    backgroundColor: '#f9fafb',
                    borderRadius: '8px',
                    marginTop: '1rem'
                }}>
                    <p style={{ margin: 0 }}>No courses found. Click "Add New Course" to create one.</p>
                </div>
            ) : (
                <div className="admin-table-wrapper">
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Category</th>
                                <th>Duration</th>
                                <th>Level</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {courses.map((course) => (
                                <tr key={course.id}>
                                    <td><strong>{course.title}</strong></td>
                                    <td>{course.category}</td>
                                    <td>{course.duration}</td>
                                    <td>{course.level}</td>
                                    <td>
                                        <span className={`admin-status-badge ${course.is_active ? 'admin-status-active' : 'admin-status-inactive'}`}>
                                            {course.is_active ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="admin-actions">
                                            <button className="admin-edit-btn" onClick={() => handleEdit(course)}>Edit</button>
                                            <button className="admin-delete-btn" onClick={() => handleDelete(course.id)}>Delete</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {showModal && (
                <div className="admin-modal-overlay" onClick={() => resetForm()}>
                    <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="admin-modal-header">
                            <h2>{editing ? 'Edit Course' : 'Add New Course'}</h2>
                            <button className="admin-modal-close" onClick={resetForm}>×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            {serverError && (
                                <div className="admin-server-error" style={{ 
                                    backgroundColor: '#f8d7da', 
                                    color: '#721c24', 
                                    padding: '0.75rem', 
                                    borderRadius: '0.375rem',
                                    marginBottom: '1rem',
                                    border: '1px solid #f5c6cb',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}>
                                    <strong>Error:</strong> {serverError}
                                </div>
                            )}
                            <div className="admin-form-group">
                                <label>Title *</label>
                                <input
                                    type="text"
                                    value={formData.title}
                                    onChange={(e) => setFormData({...formData, title: e.target.value})}
                                    required
                                    placeholder="Enter course title"
                                />
                                {errors.title && <div className="admin-error" style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                    {errors.title[0]}
                                </div>}
                            </div>
                            <div className="admin-form-group">
                                <label>Category *</label>
                                <input
                                    type="text"
                                    value={formData.category}
                                    onChange={(e) => setFormData({...formData, category: e.target.value})}
                                    required
                                    placeholder="e.g., Electrical, Mechanical, IT"
                                />
                                {errors.category && <div className="admin-error" style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                    {errors.category[0]}
                                </div>}
                            </div>
                            <div className="admin-form-group">
                                <label>Description</label>
                                <textarea
                                    value={formData.description}
                                    onChange={(e) => setFormData({...formData, description: e.target.value})}
                                    rows="3"
                                    placeholder="Brief description of the course"
                                />
                                {errors.description && <div className="admin-error" style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                    {errors.description[0]}
                                </div>}
                            </div>
                            <div className="admin-form-group">
                                <label>Duration *</label>
                                <input
                                    type="text"
                                    value={formData.duration}
                                    onChange={(e) => setFormData({...formData, duration: e.target.value})}
                                    placeholder="e.g., 6 Weeks, 3 Months"
                                    required
                                />
                                {errors.duration && <div className="admin-error" style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                    {errors.duration[0]}
                                </div>}
                            </div>
                            <div className="admin-form-group">
                                <label>Fee</label>
                                <input
                                    type="text"
                                    value={formData.fee}
                                    onChange={(e) => setFormData({...formData, fee: e.target.value})}
                                    placeholder="e.g., 10,000, 25,000"
                                />
                                {errors.fee && <div className="admin-error" style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                    {errors.fee[0]}
                                </div>}
                            </div>
                            <div className="admin-form-group">
                                <label>Level</label>
                                <select
                                    value={formData.level}
                                    onChange={(e) => setFormData({...formData, level: e.target.value})}
                                >
                                    {levels.map(level => (
                                        <option key={level} value={level}>{level}</option>
                                    ))}
                                </select>
                                {errors.level && <div className="admin-error" style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                    {errors.level[0]}
                                </div>}
                            </div>
                            <div className="admin-form-group">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={formData.is_active}
                                        onChange={(e) => setFormData({...formData, is_active: e.target.checked})}
                                    />
                                    Active
                                </label>
                            </div>
                            <div className="admin-form-group">
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={formData.is_featured}
                                        onChange={(e) => setFormData({...formData, is_featured: e.target.checked})}
                                    />
                                    Featured
                                </label>
                            </div>
                            <button type="submit" className="admin-submit-btn">
                                {editing ? 'Update Course' : 'Create Course'}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Courses;